import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Modal from 'js/components/modal';

const DeleteModal = (props) => {
  const { className, mounted, onDismiss, onConfirm, isActive } = props;
  const { t } = useTranslation();
  return (
    <Modal
      className={classnames('delete-modal', className)}
      onClickCancel={onDismiss}
      titleText={t('components.DeleteModal.title')}
      mounted={mounted}
      underlayClickExits={false}
      verticallyCenter
      focusTrapPaused
    >
      <h2>{t('components.FeeSchedulePage.DeleteModal.title')}</h2>
      <p>{t('components.FeeSchedulePage.DeleteModal.text')}</p>
      <div className="button-bar">
        <button
          className="button-link-appearance"
          disabled={isActive}
          onClick={onDismiss}
        >
          {t('common.cancel')}
        </button>
        <button
          className="button button-highlight"
          disabled={isActive}
          onClick={onConfirm}
        >
          {isActive
            ? t('components.FeeSchedulePage.DeleteModal.deleting')
            : t('components.FeeSchedulePage.DeleteModal.delete')}
        </button>
      </div>
    </Modal>
  );
};

DeleteModal.defaultProps = {
  mounted: false,
  isActive: false,
};

DeleteModal.propTypes = {
  className: PropTypes.string,
  mounted: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default DeleteModal;
